'use strict';

var _require = require('./Component'),
    CopyToClipboard = _require.CopyToClipboard;

CopyToClipboard.CopyToClipboard = CopyToClipboard;
module.exports = CopyToClipboard;


//////////////////
// WEBPACK FOOTER
// ./~/react-copy-to-clipboard/lib/index.js
// module id = 310
// module chunks = 0